import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  // Private subject holding the current loading state
  private _loading = new BehaviorSubject<boolean>(false);
  // Public observable that components can subscribe to for loader state changes
  readonly loading$ = this._loading.asObservable();

  constructor(private route: Router) {}
  /**
   * Turn the loader on.
   */
  show() {
    this._loading.next(true);
  }

  /**
   * Turn the loader off.
   */

  hide() {
    this._loading.next(false);
  }

  /**
   * Navigate to a route while automatically showing the loader
   * until navigation completes.
   *
   * @param route — The route path (string or array) to navigate to.
   * @param data? — Optional payload to send as query parameter `id`.
   */

  navigateWithLoader(route: any, data?: any) {
    this.show();

    // Listen for navigation end
    const navEndSub = this.route.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.hide();
        navEndSub.unsubscribe(); // Unsubscribe to prevent memory leaks
      });

    if (data) {
      this.route.navigate([route], { queryParams: { id: data } });
    } else {
      this.route.navigate([route]);
    }
  }

  /**
   * Returns whether the loader is currently visible.
   * @returns `true` if the loader is shown, otherwise `false`.
   */
  get isShown(): boolean {
    return this._loading.value;
  }
}
